export default function XSeriesSection() {

  const models = [
    {
      model: "Airdog X3",
      coverage: "860 sq. ft.",
      desc: "Compact & whisper-quiet — ideal for bedrooms and home offices.",
    },
    {
      model: "Airdog X5",
      coverage: "1,600 sq. ft.",
      desc: "The sweet spot for most homes. Our best-selling model for a reason.",
      badge: "Best Seller",
    },
    {
      model: "Airdog X8",
      coverage: "4,000 sq. ft.",
      desc: "Built for open-concept living — cleans 1,000 sq. ft. in 15 minutes.",
      badge: "Most Powerful",
    },
    {
      model: "Airdog Pet (P50)",
      coverage: "Up to 1,600 sq. ft.",
      desc: "Tuned for pet dander and hair. Washable plates, no filter swaps.",
      tag: "Pet Friendly",
    },
    {
      model: "Airdog V5 (Car)",
      coverage: "10–50 sq. ft.",
      desc: "Portable 12V / USB purifier for cars and RVs.",
      tag: "Portable",
    },
  ];

  return (
    <section id="models" className="py-8 md:py-10 bg-white scroll-mt-20 overflow-hidden relative z-0">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">

        {/* Header */}
        <div className="text-center mb-5 md:mb-6">
          <span className="inline-block text-[10px] font-black tracking-[0.2em] uppercase text-brand mb-1">
            Full Lineup
          </span>
          <h2 className="text-lg md:text-xl font-bold text-gray-900">
            Every Airdog Model
          </h2>
        </div>

        {/* Models List */}
        <div className="max-w-2xl mx-auto space-y-1.5">
          {models.map((m, i) => (
            <div
              key={i}
              className="flex items-center gap-3 px-3 py-2 rounded-lg bg-[#FAFAFA] border border-gray-100 hover:border-brand/20 hover:bg-white transition-colors duration-300 cursor-pointer"
            >
              {/* Model name + badge */}
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-1.5 flex-wrap">
                  <span className="text-[13px] font-bold text-gray-900 whitespace-nowrap">{m.model}</span>
                  {m.badge && (
                    <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-[8px] font-bold tracking-wider uppercase bg-brand text-white whitespace-nowrap">
                      {m.badge}
                    </span>
                  )}
                  {m.tag && (
                    <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-[8px] font-bold bg-gray-200 text-gray-600 whitespace-nowrap">
                      {m.tag}
                    </span>
                  )}
                </div>
                <p className="text-[11px] text-gray-500 font-bold mt-0.5 leading-snug">{m.desc}</p>
              </div>

              {/* Sq ft */}
              <div className="shrink-0 flex items-center gap-1">
                <i className="ri-ruler-line text-gray-400 text-[11px]" />
                <span className="text-[13px] font-bold text-gray-900 whitespace-nowrap">{m.coverage}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Shop Airdog CTA */}
        <div className="mt-6 md:mt-8 text-center">
          <button
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl bg-brand text-white font-bold text-sm hover:bg-brand/90 transition-colors duration-300 cursor-pointer shadow-sm"
            aria-label="Shop Airdog"
          >
            <i className="ri-shopping-bag-3-line text-base" />
            Shop Airdog
          </button>
        </div>

      </div>
    </section>
  );
}